import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import Cookie from "js-cookie";

// Create the auth store with persistence
export const useAuthStore = create(
  persist(
    (set, get) => ({
      // State
      user: null,
      token: null,
      isLoading: false,
      isAuthenticated: false,

      // Actions
      setUser: (user) =>
        set({
          user,
          isAuthenticated: !!user,
        }),

      setToken: (token) =>
        set({
          token,
          isAuthenticated: !!token,
        }),

      setLoading: (isLoading) => set({ isLoading }),
      // Logout action
      logout: async () => {
        Cookie.remove("token");
        Cookie.remove("refreshToken");
        // Clear auth data regardless of API call result
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          isLoading: false,
        });

        // Remove token from axios defaults
        delete axios.defaults.headers.common["Authorization"];
      },
    }),
    {
      name: "auth-storage", // unique name for localStorage key
      storage: createJSONStorage(() => localStorage), // use localStorage
      partialize: (state) => ({
        token: state.token,
        user: state.user,
      }), // only persist token and user data
      onRehydrateStorage: () => (state) => {
        // Set axios token if it exists
        if (state?.token) {
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${state.token}`;
        }
      },
    }
  )
);
